import { render, staticRenderFns } from "./WaiverDrawer.vue?vue&type=template&id=71a471d7&scoped=true"
import script from "./WaiverDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaiverDrawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WaiverDrawer.vue?vue&type=style&index=0&id=71a471d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a471d7",
  null
  
)

export default component.exports